<script>
    import Layout from "../../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Forms from "../../../../mixins/Forms";
    import axios from 'axios';

    /**
     * Ticket whatsapp template edit component
     */
    export default {
        page: {
            title: "Edit Ticket WhatsApp Template",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader},
        mixins: [Forms],
        created() {
            this.loadTicketWhatsappTemplate(this.$route.params.id);
        },
        data() {
            return {
                title: "Edit Ticket WhatsApp Template",
                items: [
                    {
                        text: "Settings",
                        href: "#"
                    },
                    {
                        text: "Edit Ticket WhatsApp Template",
                        active: true
                    }
                ],
                ticketWhatsappTemplate: null,
                serverErrors: [],
                isLoading: false,
                isSaving: false
            };
        },
        methods: {
            loadTicketWhatsappTemplate(id) {
                let vm = this;
                vm.ticketWhatsappTemplate = null;
                vm.isLoading = true;
                axios.get(API_BASE + '/ticket-whatsapp-templates/' + id).then(r => {
                    vm.isLoading = false;
                    vm.ticketWhatsappTemplate = r.data;
                }).catch(e => {
                    console.log(e);
                    vm.isLoading = false;
                    vm.setErrors(e);
                });
            },

            attemptSave() {
                this.save();
            },

            save() {
                let vm = this;
                vm.isSaving = true;
                axios.put(API_BASE + '/ticket-whatsapp-templates/' + this.ticketWhatsappTemplate.id, {
                    name: vm.ticketWhatsappTemplate.name,
                    body: vm.ticketWhatsappTemplate.body,
                    twilio_template_sid: vm.ticketWhatsappTemplate.twilio_template_sid
                }).then(r => {
                    vm.isSaving = false;
                    vm.$router.push('/settings/ticket-whatsapp-templates/');
                    this.$notify.success({
                        title: 'Success!',
                        message: 'Template updated successfully'
                    });
                }).catch(e => {
                    console.log(e);
                    vm.isSaving = false;
                    vm.setErrors(e);
                });
            }
        }
    };
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items"/>
        <errors :error-list="serverErrors"></errors>
        <loading-screen :is-loading="isLoading||isSaving"></loading-screen>
        <div class="row" v-if="ticketWhatsappTemplate">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <form @submit.prevent="attemptSave">
                            <div class="form-group row mb-4">
                                <label for="subject" class="col-form-label col-lg-2">Name</label>
                                <div class="col-lg-10">
                                    <input
                                            id="name"
                                            name="name"
                                            type="text"
                                            class="form-control"
                                            v-model="ticketWhatsappTemplate.name"
                                            autofocus
                                    />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="template" class="col-form-label col-lg-2">Template</label>
                                <div class="col-lg-10">
                                    <textarea
                                        id="body"
                                        name="body"
                                        class="form-control"
                                        rows="5"
                                        v-model="ticketWhatsappTemplate.body"
                                    ></textarea>
                                </div>
                            </div>
                            <div class="form-group row mb-4">
                                <label for="twilio_template_sid" class="col-form-label col-lg-2">Twilio Template SID</label>
                                <div class="col-lg-10">
                                    <input
                                        id="twilio_template_sid"
                                        name="twilio_template_sid"
                                        type="text"
                                        class="form-control"
                                        v-model="ticketWhatsappTemplate.twilio_template_sid"
                                        placeholder="Optional"
                                    />
                                </div>
                            </div>
                        </form>
                        <div class="row justify-content-end">
                            <div class="col-lg-10">
                                <button type="submit" class="btn btn-itg-dark" @click.prevent="attemptSave">Update</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style scoped>
</style>
